import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TimeScale } from 'chart.js';
import { param } from 'cypress/types/jquery';
import { iif, Subscription } from 'rxjs';
import { downloadCsv, yearsList } from 'src/app/core/utils/utils';
import { IFinantialReport } from 'src/app/shared/interfaces/finantial-report/ifinantial-report';
import { Filter } from 'src/app/shared/models/filter';
import { IFilterModel } from 'src/app/shared/models/filter-model';
import { FinantialReportService } from 'src/app/shared/services/finantial-report.service';
import { UserService } from 'src/app/shared/services/user.service';
import { finantialReportActions } from 'src/app/store/finantial-report/finantial-report.actions';
import { selectFinantialReport } from 'src/app/store/finantial-report/finantial-report.selectors';
import { loadUnidade } from 'src/app/store/unidade/unidade.actions';
import { selectUnitActiveList } from 'src/app/store/unidade/unidade.selectors';

@Component({
  selector: 'app-finantial-report',
  templateUrl: './finantial-report.component.html',
  styleUrls: ['./finantial-report.component.scss']
})
export class FinantialReportComponent implements OnInit {


  protected currentYear = new Date().getFullYear();
  protected activeUnit = localStorage.getItem('unitId');
  protected formFilter = this.fb.group({
    year: [this.currentYear],
    unit: []
  });

  protected listYear = [
    { label: `Ultimos 12 meses`, value: this.currentYear },
    { label: `${this.currentYear! - 1}`, value: this.currentYear! - 1 },
    { label: `${this.currentYear! - 2}`, value: this.currentYear! - 2 },
    { label: `${this.currentYear! - 3}`, value: this.currentYear! - 3 },
    { label: `${this.currentYear! - 4}`, value: this.currentYear! - 4 },
  ];
  protected listUnit: any = [];
  protected userID = localStorage.getItem('userId')
  protected user: any;


  typeAppointment: 'Atendimentos' | 'Procedimentos' | 'Exames' = 'Atendimentos';
  filterResultGraphic = new Filter();
  filterResultAppointment = new Filter();
  filterComparative = new Filter();
  filterAnnualReport = new Filter();
  filterMonthMov = new Filter();


  protected optionsReport = [
    { label: 'Atendimentos', value: "services" },
    { label: 'Procedimentos', value: "procedures" },
    { label: 'Exames', value: "exams" },
  ];

  protected optionResult = [
    {name: 'Real', id: 2},
    {name: 'Ajustado', id: 1}
  ];

  protected selectedOption: any = this.optionResult[0];

  protected appointmentType: any = this.optionsReport[0];

  protected resultsReportYearMonth: {
    current: any,
    previous: any,
    data: any,
    labels: any
  } = {
    current: 0,
    previous: 0,
    data: [],
    labels: []
  };
  protected resultServices: {
    data: any,
    columns: any
  } = {
    columns : [],
    data : {}
  };

  protected resultsComparativeExpenses: {
    previousRevenue: any,
    previousExpense: any,
    previousLabel?: any,
    data: any,
    labels: any
  } = {
    previousRevenue: 0,
    previousExpense: 0,
    data: [],
    labels: []
  }



  resultsExamYearMonth !: {
    current: any,
    data: any,
    labels: any
  }


  resultsAnnual: any [] = [];
  receiptMonthly: any[] = [];
  revenueExpenseByYear: any[] = [];

  filter = new Filter();

  isLoadingMonthMov = false;
  isLoadingAnnualResult = false;
  constructor(private fb: FormBuilder,
    private store: Store, 
    private userService: UserService,
    private finantialReportService: FinantialReportService
  ) {}
  createFilterYears() : any{
     return yearsList().map(year => {
      return {
        label: year.toString(),
        command: () => {}
      }
    });
  }
  ngOnInit(): void {
    this.userService.getbyID(Number(this.userID)).subscribe(res => {
      this.listUnit = res.units;
      this.user = res;
    });

    this.formFilter.valueChanges.subscribe(res => {
      this.loadFilter();
      this.loadGraphicResults();
      this.loadGraphicResultServiceByCategory();
      this.loadResultAnualRevenue();
      this.loadResultMonthToMonth();
    });

    this.loadFilter();
    this.loadGraphicResults();
    this.loadGraphicResultServiceByCategory();
    this.loadResultAnualRevenue();
    this.loadResultMonthToMonth();
  
  }

  loadFilter() {
    let year = this.formFilter.get('year')?.value
    let unit = this.formFilter.get('unit')?.value
    let after = `${year}-01-01`;
    let before = `${year}-12-31`;

    if(this.currentYear == year) {
      const now = new Date();
      before = new DatePipe('pt-BR').transform(now, 'yyyy-MM-dd') as string;
      let afterDate = new Date(now.getFullYear(), now.getMonth() - 11, 1);
      after = new DatePipe('pt-BR').transform(afterDate, 'yyyy-MM-dd') as string;
    }
    this.filter.clearFilter("unit");
    this.filter.date("date", after, "after");
    this.filter.date("date", before, "before");
    this.filter.filter("professional", this.userID as string);
    this.filter.filter("result", this.selectedOption.id);
    if(unit != null) {
      this.filter.filter("unit", unit);
    }
  }

  loadGraphicResults(params: string = '') {
    let filter = this.filter.convertFilterInQuery();
    this.finantialReportService.getResult(filter)
    .subscribe(res => {
      res.reverse();

      let year = this.formFilter.get('year')?.value

      let result = {
        gradientColors: ['rgba(0, 160, 0, 1)', 'rgba(255, 255, 255, 0)'],
        data: res.map((obj: any) => obj.result)
      }
      let revenue = {
        gradientColors: ['rgba(0, 160, 0, 1)', 'rgba(255, 255, 255, 0)'],
        data: res.map((obj: any) => obj.revenue)
      }

      let expense = {
        gradientColors: ['rgba(235,0,0,1)', 'rgba(255, 255, 255, 0)'],
        data: res.map((obj: any) => obj.expense)
      }

      let labels =  res.map((obj: any) => {
        let date = new Date(obj.label);
        date.setTime( date.getTime() + date.getTimezoneOffset()*60*1000 );
        let datePipe = new DatePipe("pt-BR").transform(date, 'MM/yyyy');
        return datePipe
      });


      this.resultsReportYearMonth.labels = labels;
      this.resultsReportYearMonth.current = res[res.length - 1 ].result;
      this.resultsReportYearMonth.previous = res[res.length - 2].result;
      this.resultsReportYearMonth.data = [result];

      if(this.currentYear == year) {
        this.resultsComparativeExpenses.previousLabel = labels[labels.length - 2];
        this.resultsComparativeExpenses.previousRevenue = res[res.length - 2].revenue;
        this.resultsComparativeExpenses.previousExpense = res[res.length - 2].expense;
      } else {
        this.resultsComparativeExpenses.previousLabel = labels[labels.length - 1];
        this.resultsComparativeExpenses.previousRevenue = res[res.length - 1].revenue;
        this.resultsComparativeExpenses.previousExpense = res[res.length - 1].expense;
      }

      this.resultsComparativeExpenses.labels = labels;
      this.resultsComparativeExpenses.data = [revenue, expense];
    });
  }

  loadGraphicResultServiceByCategory() {
    let filter = this.filter.convertFilterInQuery();
    this.finantialReportService.getResultServiceByCategory(filter).subscribe(res => {
      res.reverse();
      this.resultServices.columns = res.map((obj: any) => {
        let date = new Date(obj.label);
        date.setTime( date.getTime() + date.getTimezoneOffset()*60*1000 );
        let datePipe = new DatePipe("pt-BR").transform(date, 'MM/yyyy');
        return datePipe
      });
      this.resultServices.data.exams = {
        data: [],
        count: 0
      };
      this.resultServices.data.procedures = {
        data: [],
        count: 0
      };
      this.resultServices.data.services = {
        data: [],
        count: 0
      };

      res.forEach((element: any) => {
        this.resultServices.data.exams.data.push(element.exams);
        this.resultServices.data.exams.count += element.exams;
        this.resultServices.data.procedures.data.push(element.procedures);
        this.resultServices.data.procedures.count += element.procedures;
        this.resultServices.data.services.data.push(element.services);
        this.resultServices.data.services.count += element.services;
      })
      
    })
  }

  loadResultAnualRevenue() {
    this.isLoadingAnnualResult = true;
    let filter = new Filter();
    filter.filters = [...this.filter.filters];
    filter.date('date', `${this.currentYear - 4}-01-01`, 'after');
    this.finantialReportService.getResultRevenueAnual(filter.convertFilterInQuery()).subscribe(res => {
      this.isLoadingAnnualResult = false;
      this.resultsAnnual = res.map((result: any) => {return {ano: new Date(result.label).getFullYear(), value: {profit: result.value}}});
    })
  }

  loadResultMonthToMonth() {
    this.isLoadingMonthMov = true;
    let filter = this.filter.convertFilterInQuery();

    let result = this.filter.getFilterValue("result");
    iif(() => result == 1,
    this.finantialReportService.getResult(filter),
    this.finantialReportService.getResultMonthToReal(filter))
    .subscribe(res => {
      this.isLoadingMonthMov = false;
      this.receiptMonthly = [];
      res.forEach((item : any) => {
        let columns = [];
        columns.push({
          valor: item['revenue'],
          descricao: 'Rec. total'
        });
        columns.push({
          valor: item['expense'],
          descricao: 'Despesas'
        });
        columns.push({
          valor: item['result'],
          descricao: 'Resultado Liquido'
        });

        this.receiptMonthly.push({
          percentage: 0,
          data: new DatePipe("pt-BR").transform(new Date(item.label), 'yyyy-MM-dd'),
          columns: columns
        });
      });
    });
  }

  onFilterEvent(event: IFilterModel[]) {
    event.forEach(e => {
      this.filter.setFilter(e.key, e.filter);
    });
    //let result = this.filter.getFilterValue("result");
    //this.selectedOption = result == 1 ? this.optionResult[0] : this.optionResult[1];
    this.loadResultMonthToMonth(); 
  }  

  setAppointmentTypeFilter(event: any) {
    this.appointmentType = event;
  }



}


